// @flow

import React from 'react'
import EmbeddedMap from 'components/shared/EmbeddedMap'
import { googleMapUrl } from 'frontend_core/dist/helpers/url'
import PreWrap from 'components/atoms/PreWrap'

export type PropTypes = {
  name: string,
  access: string,
  latitude: number,
  longitude: number,
  state: string,
  city: string,
  address1: string,
  address2: string,
  googleMapReactBootstrapURLKeys?: ?Object,
}

export default (props: Object) => (
  <section className="space-main__section-big pace-main__maparea pace-main__maparea-sp pc-hide__sm-show">
    <div className="space-main__map">
      <EmbeddedMap
        lat={parseFloat(props.latitude)}
        lng={parseFloat(props.longitude)}
        zoom={15}
        url={googleMapUrl(props.latitude, props.longitude, props.name)}
        googleMapReactBootstrapURLKeys={props.googleMapReactBootstrapURLKeys}
      />
    </div>
    <div className="space-main__access">
      <h2 className="space-main__access-title">
        {i18n.t('page.room.address')}
      </h2>
      <p className="space-main__access-content">{`${props.state ||
        ''}${props.city || ''}${props.address1 || ''}${props.address2 ||
        ''}`}</p>
      <h2 className="space-main__access-title">{i18n.t('page.room.access')}</h2>
      <PreWrap>
        <p className="space-main__access-content">{props.access}</p>
      </PreWrap>
      <p className="space-main__access-link">
        <a
          href={googleMapUrl(props.latitude, props.longitude, props.name)}
          target="_blank"
        >
          <i className="fa fa-map mr5" />
          {i18n.t('page.shared.openMap')}
        </a>
      </p>
    </div>
  </section>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailAccessSectionSp/index.jsx